import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ClientAuthService } from '../../services/auth/client-auth.service';
import { authConfig } from 'projects/reg-hub-client/src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRepositoryService } from 'reg-hub-common';

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyAccountComponent {
  username: string = "";
  email: string = "";
  isTwoFactorEnabled: boolean = false;
  constructor(private authService: ClientAuthService,
              private router: Router,
              private route: ActivatedRoute,
              private userService: UserRepositoryService) { }

  ngOnInit(): void {
    this.username = this.authService.getUserNameFromToken() ?? "";
    this.userService.getAuthenticatedUser().subscribe(user => {
      this.isTwoFactorEnabled = user?.isTwoFactorEnabled ?? false;
    });
  }

  changePassword(): void {
    const returnUrl = encodeURIComponent(window.location.origin + "/callback");

    const identityServerUrl = `${authConfig.authority}/account/changepassword?username=${this.username}&returnurl=${returnUrl}`;
    window.location.href = identityServerUrl;
  }

  viewAuthenticator(): void {
    const returnUrl = encodeURIComponent(window.location.origin + "/callback");

    const identityServerUrl = `${authConfig.authority}/account/qrcode?username=${this.username}&returnurl=${returnUrl}&ischange=false`;
    //window.location.href = identityServerUrl;
    window.open(identityServerUrl, '_blank');
  }
}
